import { Box, Typography } from '@mui/material';
import { AI_GRADIENT_STOPS } from 'common/constants/ai';
import AISuggestionPopover from './AISuggestionPopover';
import { SuggestedDocumentReferenceProps } from './SuggestedDocumentReference.props';
import {
  chipTextSx,
  chipTriggerSx,
  svgBorderStyle,
} from './SuggestedDocumentReference.styles';

const CLASSIFICATION_DISPLAY_MAP: Record<string, string> = {
  CAP_TABLE: 'Cap Table',
  BALANCE_SHEET: 'Balance Sheet',
  INCOME_STATEMENT: 'Income Statement',
  CASH_FLOW_STATEMENT: 'Cash Flow Statement',
  OTHER: 'Other',
};

const SuggestedDocumentReference = ({
  documentReference,
  onAccept,
  onDecline,
}: SuggestedDocumentReferenceProps) => {
  const gradientId = `ai-gradient-border-${documentReference.document_reference_id}`;
  const classification = documentReference.ai_classification;
  const classificationResult = classification?.classification_result || 'Document';
  const displayName = CLASSIFICATION_DISPLAY_MAP[classificationResult] || classificationResult;

  const suggestedReference = documentReference.referenced_in?.[0];
  const referenceType = suggestedReference?.reference_object_type || displayName;

  return (
    <AISuggestionPopover
      documentReferenceId={documentReference.document_reference_id}
      aiClassification={documentReference.ai_classification}
      referencedIn={documentReference.referenced_in}
      onAccept={onAccept}
      onDecline={onDecline}
    >
      {({ onMouseEnter, onMouseLeave, ariaDescribedBy }) => (
        <Box
          aria-describedby={ariaDescribedBy}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          sx={chipTriggerSx}
        >
          <svg style={svgBorderStyle}>
            <defs>
              <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                {AI_GRADIENT_STOPS.map(stop => (
                  <stop key={stop.offset} offset={stop.offset} stopColor={stop.color} />
                ))}
              </linearGradient>
            </defs>
            <rect
              x="1"
              y="1"
              rx="16"
              ry="16"
              fill="none"
              stroke={`url(#${gradientId})`}
              strokeWidth="2"
              strokeDasharray="6 4"
              style={{ width: 'calc(100% - 2px)', height: 'calc(100% - 2px)' }}
            />
          </svg>
          <Typography variant="body2" sx={chipTextSx}>
            {referenceType}
          </Typography>
        </Box>
      )}
    </AISuggestionPopover>
  );
};

export default SuggestedDocumentReference;
